import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ICONS from "../../../../../assets/Icons";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider";
import TEXT from "../../../../../utils/globalText";
import BankDetails from "../../../../_utils/AccountCreationComponents/BankDetails";
import ConfirmBtnAccCreation from "../../../../_utils/AccountCreationComponents/ConfirmBtnAccCreation";
import ActiveInactiveAssociatePopup from "../../../../_utils/ActiveInactiveAssociatePopup";
import CommonAlertCard from "../../../../_utils/CommonAlertCard";
import CommonLayout from "../../../../_utils/CommonLayout";
import ConfidentialCard from "../../../../_utils/TransactionCommonComponents/ConfidentialCard";
import "./index.css";

const BeneficiaryAccountEditStepBank = ({
  isResolving,
  bankLookupNext,
  setBankLookupNext,
  setIsNextButtonEnabled,
  payload,
  setPayload,
  activeStep,
  bankLookupData,
  isIFSCValid,
  isBankLinkedAccount,
  accountActiveInactiveState,
  setAccountActiveInactiveState,
  currentAssociate,
  setCurrentAssociate,
  openAssociatePopup,
  setOpenAssociatePopup,
  dropDownOptions,
  virtualAccount,
  setVirtualAccount,
  bankVerificationStatus,
  setBankVerificationStatus,
  verifyBankAccountError,
  setBankUserInfo,
  setShowAccInfo,
  showAlreadyLinkedAlert,
  isVirtualDetected,
  id,
  isNextButtonEnabled,
  isNewBank,
  manualVirtualAccount,
  setManualVirtualAccount,
  setConfirmEnable,
  verifiyBankAccountMessage,
  verifyBankAccountData,
  bankLookupError,
  setIsOriginalManualVirtual,
  isOriginalManualVirtual,
  virtualType,
  setVirtualType,
  beneficiaryAccountDetailsLoading,
  bankLookupLoading,
  verifyBankAccountLoading,
}) => {
  const { ifscDetailsData, ifscDetailsError, ifscDetailsLoading } = useSelector(
    (state) => state.sharedResources,
  );
  const ifscData = ifscDetailsData?.ifsc_details?.[0];

  const [showDetails, setShowDetails] = useState(null);

  useEffect(() => {
    if (
      !beneficiaryAccountDetailsLoading &&
      !ifscDetailsLoading &&
      !bankLookupLoading &&
      !verifyBankAccountLoading &&
      !bankLookupData?.beneficiary_accounts?.length &&
      !verifyBankAccountError &&
      isIFSCValid &&
      bankLookupError === true &&
      verifyBankAccountData
    ) {
      setShowDetails(true);
    } else {
      setShowDetails(false);
    }
  }, [
    bankLookupLoading,
    verifyBankAccountLoading,
    bankLookupData,
    verifyBankAccountError,
    isIFSCValid,
    beneficiaryAccountDetailsLoading,
    bankLookupError,
    verifyBankAccountData,
    ifscDetailsLoading,
  ]);

  return (
    <>
      <div className="max-w-tab-width-normal w-full mx-auto">
        <CommonLayout>
          <>
            {/* {!isResolving && showJointAccountAlert && createNewedit && (
              <CommonAlertCard texts="Updating the bank details will transform this account into a joint account since there are several PANs associated with it and adds it to the active accounts for the provided bank details." />
            )} */}

            {!beneficiaryAccountDetailsLoading && !ifscDetailsLoading && !verifyBankAccountLoading && !isResolving && isVirtualDetected && isIFSCValid && (
              <CommonAlertCard
                title="Virtual Account Detected"
                texts={[
                  "Account could not be verified as it is virtual account.",
                  "Self verify and proceed with caution.",
                ]}
                icon={ICONS?.VIRTUAL_ACCOUNT}
              />
            )}

             {!isResolving && showAlreadyLinkedAlert && (
              <CommonAlertCard texts="The bank account is already linked to the provided PAN. To proceed, update the bank details associated with the account." />
            )}

            <BankDetails
              payload={payload}
              setPayload={setPayload}
              BenEnableNextButton={setIsNextButtonEnabled}
              activeStep={activeStep}
              setVirtualAccount={setVirtualAccount}
              setBankUserInfo={setBankUserInfo}
              setShowAccInfo={setShowAccInfo}
              bankLookupNext={bankLookupNext}
              setBankLookupNext={setBankLookupNext}
              bankVerificationStatus={bankVerificationStatus}
              setBankVerificationStatus={setBankVerificationStatus}
              virtualAccount={virtualAccount}
              isIFSCValid={isIFSCValid}
              manualVirtualAccount={manualVirtualAccount}
              setManualVirtualAccount={setManualVirtualAccount}
              ifscData={ifscData}
              ownerAccIfscError={ifscDetailsError}
              ownerAccIfscLoading={ifscDetailsLoading}
            />
          </>
          <div>
            <div
              className={`${manualVirtualAccount && !isOriginalManualVirtual && " opacity-light-opacity pointer-events-none"}`}
            >
              {(manualVirtualAccount ||
                (bankLookupError === true &&
                  verifyBankAccountError === true &&
                  verifiyBankAccountMessage ===
                    "Invalid Bank Account Number / IFSC" &&
                  isIFSCValid &&
                  !ifscDetailsError &&
                  !ifscDetailsLoading)) && (
                <ConfidentialCard
                  icon={ICONS.VIRTUAL_ACCOUNT}
                  title={TEXT?.MARK_VIRTUAL_ACCOUNT}
                  note={TEXT?.VIRTUAL_ACCOUNT_NOTE}
                  toggleState={
                    virtualType === "Mark-Virtual"
                      ? isOriginalManualVirtual
                      : manualVirtualAccount
                  }
                  onToggle={() => {
                    if (
                      !isIFSCValid ||
                      ifscDetailsError ||
                      ifscDetailsLoading
                    ) {
                      return;
                    }
                    const nextState = !isOriginalManualVirtual;
                    setManualVirtualAccount(nextState);
                    setVirtualType("Mark-Virtual");
                    setIsOriginalManualVirtual(nextState);
                    setPayload((prev) => ({
                      ...prev,
                      virtual: nextState,
                    }));

                    if (!nextState && verifyBankAccountError) {
                      setIsNextButtonEnabled(true);
                    }
                  }}
                />
              )}
            </div>

            <div className={` ${manualVirtualAccount && "mt-margin-md"} `}>
              {" "}
              {isNewBank && !showAlreadyLinkedAlert && (
                <ConfirmBtnAccCreation
                  type="remitter"
                  status={bankLookupData?.status}
                  lookupNext={isNextButtonEnabled}
                  isConfirmed={isNextButtonEnabled}
                  selected={ICONS?.SELECTED_WITH_GREEN_CIRCLE}
                  not_selected={ICONS?.NOT_SELECTED_WITH_GREY_CIRCLE}
                  handleClick={() => {
                    setIsNextButtonEnabled(true);
                    setConfirmEnable(true);
                  }}
                  isRemitter={true}
                  subtext={
                    "Confirm and click ‘Next’ to convert this account into a joint account and add it as an active account associated with the provided bank details."
                  }
                />
              )}
            </div>

            <div
              style={{
                display:
                  (bankLookupData?.status &&
                    bankLookupData?.beneficiary_accounts?.length >
                      GlobalConfiguration?.lengthCheckZero) ||
                  virtualAccount
                    ? "block"
                    : isIFSCValid && verifyBankAccountError
                      ? "none"
                      : "block",
              }}
              className={` ${manualVirtualAccount && "mt-margin-md"}`}
            >
              <ActiveInactiveAssociatePopup
                flow={
                  isBankLinkedAccount && isIFSCValid
                    ? "Existing"
                    : showDetails
                      ? "notFoundBank"
                      : !showDetails &&
                          bankLookupData?.beneficiary_accounts?.length
                        ? "Bank"
                        : "defaultBank"
                }
                dropDownNo={GlobalConfiguration?.lengthCheckZero}
                ifsc={payload?.ifsc_code}
                bank={payload?.bank_account}
                pan={payload?.pan_no}
                accActiveInactiveState={accountActiveInactiveState}
                setAccActiveInactiveState={setAccountActiveInactiveState}
                currentAssociate={currentAssociate}
                setCurrentAssociate={setCurrentAssociate}
                openAssociatePopup={openAssociatePopup}
                setOpenAssociatePopup={setOpenAssociatePopup}
                activeAssociateId={id}
                dropDownOptions={dropDownOptions}
                currentRoute="beneAccount"
                ifscLength={payload?.ifsc_code?.length}
              />
            </div>
          </div>
        </CommonLayout>
      </div>
    </>
  );
};

export default BeneficiaryAccountEditStepBank;
